export default __webpack_public_path__ + "static/media/HTML-icon.f3aa7827.png";